import React from 'react';
import styled from '@emotion/styled';
import PropTypes from 'prop-types';

import ProductPropertyTab from '../../molecules/product-detail-accordion';
import Typography from '../../atoms/typography';

const Icon = styled.img`
  max-height: 5rem;
  max-width: 5rem;
  width: 100%;

  & ~ & {
    margin-left: 1rem;
  }
`;

const AWARD_PROPERTIES = {
  'USDA Organic': '/images/usda-organic.png',
  'Made in the USA': '/images/made-in-the-usa.png',
  'Peta Badge': '/images/vegan-cruelty-free.png',
  'Leaping Bunny Badge': '/images/cruelty-free.png',
  'Cosmos Organic': '/images/cosmos-organic.png'
};

const Awards = (props) => {
  if (!props.product) return null;

  const awards = props.product?.product_properties?.filter(
    (property) => Object.keys(AWARD_PROPERTIES).includes(property.value)
  );

  if (!awards || awards.length === 0) return null;

  return (
    <ProductPropertyTab title="Awards">
      <Typography element="div" like="paragraph-2">
        {
          awards.map((item) => (
            <Icon
              key={item.id}
              src={`${process.env.NEXT_PUBLIC_ASSET_HOST}${AWARD_PROPERTIES[item.value]}`}
              alt={item.value}
            />
          ))
        }
      </Typography>
    </ProductPropertyTab>
  );
};

Awards.propTypes = {
  product: PropTypes.object.isRequired
};

export default Awards;
